import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { EmployeesListService } from '../../../../modules/employees/employees-list.service';
import { MasterService } from '../../../master/services/master.service';
import { bankAccountOptions, EntityFormOption } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class CreditFormLookupsFacade {

  constructor(
    private masterService: MasterService,
    private employeesListService: EmployeesListService,
  ) { }

  bankAccounts(): Promise<EntityFormOption[]> {
    return firstValueFrom(this.masterService.getBankAccounts()).then(list => bankAccountOptions(list));
  }

  employees(): Promise<EntityFormOption[]> {
    return this.employeesListService.getList().then(list => (list || [])
      .filter(employee => employee && employee.uid != null)
      .map(employee => ({ id: employee.uid, display: employee.name || '' })));
  }
}
